import React from "react";
import ProductCart from "./ProductCart";

const products = [
  {
    id: 1,
    title: " ",
  },
  {
    id: 2,
    title: " ",
  },
  {
    id: 3,
    title: " ",
  }
]

const Materiales = () => {
  return (
    <div>
      <section className="inner_page_head" id="product_title">
        <div className="container_fuild">
          <div className="row">
            <div className="col-md-12">
              <div className="full">
                <h3>Materiales</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="product_section layout_padding">
        <div className="container">
          <div className="row">
            {products.map((product) => (
              <ProductCart
                product={product}
                key={product.id}
                model={""}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Materiales;
